import { UserApi } from './';
import {SSE} from '../helper';

const {REACT_APP_API_BASE_URL} = process.env;

export class ImagesApi {
    static getAllImages (eventID) {
        return fetch(`${REACT_APP_API_BASE_URL}/api/me/events/${eventID}/images`, {
            ...UserApi.GetDefualtMethod
        });
    }

    static updateImage (eventID, imageID, data) {
        return fetch(`${REACT_APP_API_BASE_URL}/api/me/events/${eventID}/images/${imageID}`, {
            ...UserApi.PostDefualtMethod,
            method: 'PUT',
            body: JSON.stringify(data)
        });
    }

    static deleteImage (eventID, imageID) {
        return fetch(`${REACT_APP_API_BASE_URL}/api/me/events/${eventID}/images/${imageID}`, {
            ...UserApi.PostDefualtMethod,
            method: 'DELETE'
        });
    }

    static imagesStream(eventID) {
        return new SSE({
            url: `${REACT_APP_API_BASE_URL}/api/me/events/${eventID}/images/stream`,
            withCredentials: true
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/images.js